import type { TaskWaiting, TaskWaitingRef } from '@shared/types/tasks';

/** Waiting on (T-331): one key per person, task or the AI builder. */
export const waitingKey = (w: TaskWaitingRef | TaskWaiting) =>
  w.target === 'user' ? `user:${w.user_id}` : w.target === 'task' ? `task:${w.task_id}` : 'ai';

/** A card's wait as the API takes it back. */
export const asWaitingRef = (w: TaskWaiting): TaskWaitingRef =>
  w.target === 'user' ? { target: 'user', user_id: w.user_id } : w.target === 'task' ? { target: 'task', task_id: w.task_id } : { target: 'ai' };

/** Whether it's this person's turn on the task. */
export function isWaitingOn(waiting: TaskWaiting[], userId: string | null | undefined): boolean {
  return Boolean(userId) && waiting.some((w) => w.target === 'user' && w.user_id === userId);
}
